import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getDictionaryProofsOptions,
  useDeleteDictionaryProof,
  useUploadOrUpdateDictionaryProof,
} from './model/DictionaryProofModel';

interface DictionaryProofActionProps {
  dictionaryId: number;
  authors: Author[];
  variant?: 'compact';
}

export function DictionaryProofAction({ dictionaryId, authors }: DictionaryProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getDictionaryProofsOptions(dictionaryId));
  const uploadOrUpdateMutation = useUploadOrUpdateDictionaryProof(dictionaryId);
  const deleteMutation = useDeleteDictionaryProof(dictionaryId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="dictionary"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
